// Chat configuration for real-time functionality
export const CHAT_CONFIG = {
  // Real-time type: 'websocket' | 'polling'
  realTimeType: 'polling', // Change to 'websocket' when WebSocket server is ready
  
  // Polling configuration with adaptive intervals
  polling: {
    // Base intervals for different states
    intervals: {
      active: 3000,        // Fast polling after user activity (3s)
      normal: 5000,        // Normal polling (5s)
      idle: 10000,         // Idle state polling (10s)
      background: 10000,   // Background/inactive polling (20s)
      dormant: 10000       // Very inactive polling (60s)
    },
    
    // Exponential backoff configuration
    backoff: {
      initial: 1000,       // Initial retry delay (1s)
      multiplier: 2,       // Backoff multiplier
      maxDelay: 30000,     // Maximum backoff delay (30s)
      maxRetries: 5        // Maximum retry attempts
    },
    
    // User activity detection
    activity: {
      inactivityThreshold: 300000,  // 5 minutes of inactivity
      dormantThreshold: 900000      // 15 minutes for dormant state
    }
  },
  
  // WebSocket configuration
  websocket: {
    url: import.meta.env.VITE_WEBSOCKET_URL || 'ws://localhost:3001',
    reconnectAttempts: 5,
    reconnectInterval: 2000
  }
};

export default CHAT_CONFIG;